export enum MediaType {
	JPG = "image/jpeg",
	PNG = "image/png",
	WEBP = "image/webp",
}
